import axios from "axios";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import closeButton from "../../Assets/Images/close-btn.png";
import { AddToyApi, AddToysApi } from "../../Utils/API/ApiCall";
import { ToastContainer, toast } from "react-toastify";
import { Col, Form, Row } from "react-bootstrap";

const CreateModal = ({
  images,
  head,
  detail,
  button,
  placeholder,
  onHide,
  ...props
}) => {
  const [toyName, setToyName] = useState("");
  const [errorEmpty, setErrorEmpty] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChangeToyName = (e) => {
    e.preventDefault();
    setToyName(e.target.value);
  };
  const addToy = async (e) => {
    e.preventDefault();
    let check = true;
    if (!toyName) {
      setErrorEmpty(true);
      setErrorMsg("Toy Name should not be empty");
      check = false;
    } else if (toyName) {
      if (/^\s+$/.test(toyName) === true) {
        setErrorEmpty(true);
        setErrorMsg("Toy Name should not be empty");
        check = false;
      } else {
        setErrorEmpty(false);
      }
    } else {
      setErrorMsg(false);
    }

    if (check === true) {
      const data = {
        toy_name: toyName,
      };
      // xyz(data)
      const Response = await AddToysApi(data);
      if (Response.status == 200) {
        toast.success(Response.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else if (Response.status == 400) {
        toast.error(Response.message);
      } else {
        toast.error(Response.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    }
  };

  const handleClose = () =>{
    window.location.reload();
  }

  return (
    <>
      <div className="Modal">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <img
              src={closeButton}
              className="closeButton"
              alt="closeButton"
              onClick={handleClose}
            />
            <div className="modal-image">
              <img
                loading="lazy"
                src={images}
                alt="category image"
                className="modal_Head_Image"
              />
            </div>
            <h3>{head}</h3>
            {/* <h4>{detail}</h4> */}
            <Form onSubmit={addToy}>
              <div className="Modal-input">
                <input
                  type="text"
                  placeholder={placeholder}
                  maxLength={50}
                  value={toyName}
                  onChange={handleChangeToyName}
                ></input>
              </div>
              <p className="err-msg">{errorEmpty ? errorMsg : ""}</p>

              <button className="modal_Button" onSubmit={addToy}>
                Add
              </button>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default CreateModal;
